import { useState, useEffect } from "react";
import { MdOutlineWatchLater } from "react-icons/md";
import { AiOutlineDollar } from "react-icons/ai";
import { jobsListingApi } from "../service/apis/listing.api";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useCustomNavigate } from "../hooks/useCustomNavigate";
import { AppRoute } from "../router/routerConstants";
import Loader from "../common/Loader/loader";
import CustomPagination from "./custom-pagination";

const JobsList = (pros: any) => {
    const [responseData, setResponseData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totaldata, setTotalData] = useState(0)

    const [isLoading, setIsLoading] = useState(false);
    //const [sortOrder, setSortOrder] = useState<string>("");
    const [localSortOrder, setLocalSortOrder] = useState<string>("");

    const [NavigateTo] = useCustomNavigate();
    const { user } = useSelector((state: RootState) => state.authSlice);
    const { isLoggedIn } = useSelector((state: RootState) => state.authSlice);
    const handlePageChange = (page: any) => {
        setCurrentPage(page);
    };
    let categoryQuery: any;
    let jobTypeQuery: any;
    
    if(isLoggedIn && 
        (window.location.pathname === "/agent-flow/jobs-listing" || 
         window.location.pathname === "/jobseeker/jobs-listing")) {
    //if(isLoggedIn) {
        //console.log("LoggedIn",pros?.categories);
        categoryQuery = pros?.categories.map( (cat: any) => cat?.value).join(",");
        jobTypeQuery = pros?.jobTypes.map( (jb: any) => jb?.value).join(",");
    } else {
        //console.log("LoggedOut",pros?.categories);
        categoryQuery = pros?.categories.join(",");
        jobTypeQuery = pros?.jobTypes.join(",");
    }
    
    const salaryMinQuery = pros?.salaryMin;
    const salaryMaxQuery = pros?.salaryMax;
    const industryQuery = pros?.industry;
    const locationQuery = pros?.location;

    const handleClick = (id: string) => {
        const params = {
            jobId: id,
        };
        if (user && user?.role === "jobseeker") {
            NavigateTo(AppRoute.JOBSEEKER_JOBS_DETAILS, false, params);
        } else if (user && user?.role === "localagents") {
            NavigateTo(AppRoute.AGENT_JOBS_DETAILS, false, params);
        }else{
            NavigateTo(AppRoute.JOBS_Details, false, params);
        }
    };

    const {
        // categories,
        // jobTypes,
        // salaryMin,
        // salaryMax,
        // industry,
        // location,
        sortOrder,
        onSortChange,
    } = pros;

    const effectiveSortOrder = sortOrder || localSortOrder;

    const manageJobListing = async (pagee: number, categoryQuery: any, jobTypeQuery: any, salaryMinQuery: number, salaryMaxQuery: number, industryQuery: string, locationQuery: string, sortOrder: any) => {
        setIsLoading(true);
        try {
            const response = await jobsListingApi(pagee, categoryQuery, jobTypeQuery, salaryMinQuery, salaryMaxQuery, industryQuery, locationQuery, sortOrder);
            setResponseData(response?.jobData?.Jobs);
            setCurrentPage(response?.jobData?.page);
            setTotalPages(response?.jobData?.totalPages); 
            setTotalData(response?.jobData?.totalResults)
        } catch (error) {
            console.error("Error API job list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        manageJobListing(currentPage, categoryQuery, jobTypeQuery, salaryMinQuery, salaryMaxQuery, industryQuery, locationQuery, effectiveSortOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pros, effectiveSortOrder]);

    const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        //setSortOrder(selectedValue);
        if (onSortChange) {
            onSortChange(selectedValue);
        } else {
            setLocalSortOrder(selectedValue);
        }
    };

    // Date created ago
    const calculateTimeAgo = (date: string) => {
        const currentDate = new Date();
        const givenDate = new Date(date);
        const timeDifference = currentDate.getTime() - givenDate.getTime();
        const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        if (daysAgo === 0) {
            return 'Today';
        } else if (daysAgo === 1) {
            return '1 day ago';
        } else {
            return `${daysAgo} days ago`;
        }
    };
    // Date created ago ends

    return (
        <>
          {isLoading ? (
              <Loader />
          ) : (
              !isLoggedIn && (
                  <div className="row">
                      <div className="col-lg-12 filterHolder mb-4">
                          <div className="filterResults">
                              <h6>
                                  Results Found{" "}
                                  <span>({totaldata})</span>
                              </h6>
                          </div>
                          {/* Sort By Section */}
                          <div className="sortby-holder">
                              <h6>Sort By:</h6>
                              <Form.Select 
                                  aria-label="Default select example"
                                  onChange={handleSortChange}
                                  //value={sortOrder}
                                  value={effectiveSortOrder}
                              >
                                  <option value="">Default</option>
                                  <option value="newest">Newest</option>
                                  <option value="oldest">Oldest</option>
                                  <option value="asc">A to Z</option>
                                  <option value="desc">Z to A</option>
                              </Form.Select>
                          </div>

                      </div>
                  </div>
              )
          )}
  
          <div className="row">
              {isLoggedIn && (
                  <h6 className="text-end">
                      Results Found{" "}
                      <span>({totaldata})</span>
                  </h6>
              )}
              {responseData && responseData?.length > 0 ? (
                  responseData.map((res: any) => (
                      <div className={isLoggedIn ? "col-xl-4 col-lg-4 col-sm-6 " : "col-xl-4 col-lg-4 col-sm-6"} key={res?.id}>
                          <div
                              className="jobboxholder"
                              onClick={() => handleClick(res?.id)}
                          >
                              <div className="jobboxholdertop">
                                  <h4>{res?.title}</h4>
                                  <p>
                                      <MdOutlineWatchLater /> posted{" "}
                                      {calculateTimeAgo(res?.createdAt)}
                                  </p>
                                  <div className="timeprice">
                                      <div className="timezone">{res?.type?.typeName}</div>
                                      <div className="price">
                                          <AiOutlineDollar /> ${res?.salaryMin} - $
                                          {res?.salaryMax}/mo.
                                      </div>
                                  </div>
                              </div>
                              <div className="jobboxholderbtm">
                                  <div className="companyname">
                                      <img
                                          src={res?.userID?.profileimageurl}
                                          alt="companylogo"
                                      />
                                  </div>
                                  <h6>
                                      {res?.userID?.externalInfo &&
                                      res?.userID?.externalInfo?.name
                                          ? res?.userID?.externalInfo?.name
                                          : `${res?.userID?.firstName} ${res?.userID?.lastName}`}{" "}
                                      <span>{res?.location}</span>
                                  </h6>
                              </div>
                          </div>
                      </div>
                  ))
              ) : (
                  <div className="col-lg-12">
                      {responseData === null || responseData?.length === 0 ? (
                          <h2 className="text-center">No results found</h2>
                      ) : (
                        //   <h2 className="text-center">Loading...</h2>
                          <Loader/>
                      )}
                  </div>
              )}
          </div>

      {/* Pagination */}
      <div className="row">
        <div className="col-lg-12 paginationholder">
          <CustomPagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default JobsList;
